export const LS_KEY = 'dashboardV2Period';
export const LS_CUSTOM_KEY = 'dashboardV2CustomDates';

export function isoDate(d) {
  if (!d) return null;
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function periodToDates(period) {
  const today = new Date();
  const to = isoDate(today);
  if (period === '7d') {
    const f = new Date(today);
    f.setDate(today.getDate() - 6);
    return { from: isoDate(f), to };
  }
  if (period === '30d') {
    const f = new Date(today);
    f.setDate(today.getDate() - 29);
    return { from: isoDate(f), to };
  }
  if (period === '90d') {
    const f = new Date(today);
    f.setDate(today.getDate() - 89);
    return { from: isoDate(f), to };
  }
  if (period === 'ytd') {
    return { from: `${today.getFullYear()}-01-01`, to };
  }
  return { from: null, to: null };
}

export function getInitialDates() {
  try {
    const p = localStorage.getItem(LS_KEY) || '90d';
    if (p === 'custom') {
      const saved = JSON.parse(localStorage.getItem(LS_CUSTOM_KEY));
      if (saved?.from && saved?.to) return saved;
      return periodToDates('90d');
    }
    return periodToDates(p);
  } catch {
    return periodToDates('90d');
  }
}
